import React from 'react';
import { SizeGuideTable, SizeNotice } from '../../SizeGuide.css';
import { women as womenData } from '../../SizeGuideData';
import { renderRow, renderTable } from '../../size_guide_helpers';

const renderSizing = data => {
  const output = [];
  data[0].forEach(() => output.push([]));

  for (let row = 0; row < data.length; row++) {
    for (let col = 0; col < data[row].length; col++) {
      output[col].push(data[row][col]);
    }
  }

  return output.map(col => (
    <td>
      {col.map((el, idx) => (
        <span>
          {idx !== 0 && <br />}
          {el}
        </span>
      ))}
    </td>
  ));
};

const women = () => [
  {
    tab: 'tab_clothing',
    label: 'Clothing',
    contentGenerator: () => renderTable(womenData.clothing),
  },
  {
    tab: 'tab_jeans',
    label: 'Jeans',
    contentGenerator: () => (
      <>
        {renderTable(womenData.jeans.waist)}
        {renderTable(womenData.jeans.length)}
      </>
    ),
  },
  { tab: 'tab_shoes', label: 'Shoes', contentGenerator: () => renderTable(womenData.shoes, 0, false) },
  {
    tab: 'tab_hats',
    label: 'Hats',
    contentGenerator: () => (
      <>
        {renderTable(womenData.hats)}
        <SizeNotice>{womenData.hats_notice}</SizeNotice>
      </>
    ),
  },
  {
    tab: 'tab_gloves',
    label: 'Gloves',
    contentGenerator: () => (
      <>
        {renderTable(womenData.gloves)}
        <SizeNotice>{womenData.gloves_notice}</SizeNotice>
      </>
    ),
  },
  { tab: 'tab_belts', label: 'Belts', contentGenerator: () => renderTable(womenData.belts) },
  { tab: 'tab_rings', label: 'Rings', contentGenerator: () => renderTable(womenData.rings) },
];

export default women;
